<ng-container *ngIf="chartOptions">
  <div
    edsSpacing="md"
    edsFlexbox
    flexWrap="wrap"
    alignItems="center"
    justifyContent="space-between"
  >
    <eds-toggle-v2
      [toggleButtons]="yearGroups"
      (toggleActive)="onYearGroupUpdate($event)"
      edsPadding
      [edsPaddingBottom]="(isMobile$ | async) === false ? 'none' : 'sm'"
    ></eds-toggle-v2>
    <div
      edsCol
      alignContent="right"
      edsFlexbox
      [justifyContent]="(isMobile$ | async) === false ? 'flex-end' : ''"
      [flexWrap]="(isMobile$ | async) === false ? 'wrap' : ''"
      flexDirection="row"
      alignItems="flex-start"
      *ngIf="customHistory"
    >
      <div
        edsFlexbox
        alignItems="center"
        [flexDirection]="(isMobile$ | async) === false ? 'row' : 'column'"
      >
        <eds-month-picker
          [label]="'products.calendar-from' | translate"
          [placeholder]="datePickerFormat"
          [min]="minDateYearMonthStd"
          [max]="toDateYearMonthStd"
          [value]="fromDateYearMonthStd"
          [format]="datePickerFormat"
          (selected)="setCustomDateRange('fromDate', $event)"
          [opens]="(isMobile$ | async) === false ? 'left' : 'right'"
          [required]="true"
          [errorMsgObj]="errorMsgObj"
          [calendarHeading]="'common.month-calendar-heading' | translate"
          [closeLabel]="'common.month-close' | translate"
          [prevButtonLabel]="'common.month-previous-button' | translate"
          [nextButtonLabel]="'common.month-next-button' | translate"
          [toggleButtonLabel]="'common.month-toggle-button' | translate"
          [toggleButtonChangeLabel]="'common.month-change-button' | translate"
          [selectedDateLabel]="'common.month-selected-date' | translate"
          (openPanel)="onOpenMonthPicker($event)"
          (monthSelected)="OnMonthSelected($event)"
        ></eds-month-picker>
      </div>
      <div
        edsFlexbox
        alignItems="center"
        edsPadding
        edsPaddingLeft="sm"
        [flexDirection]="(isMobile$ | async) === false ? 'row' : 'column'"
      >
        <eds-month-picker
          [label]="'products.calendar-to' | translate"
          [placeholder]="datePickerFormat"
          [min]="fromDateYearMonthStd"
          [max]="maxDateYearMonthStd"
          [value]="toDateYearMonthStd"
          [format]="datePickerFormat"
          [required]="true"
          (selected)="setCustomDateRange('toDate', $event)"
          [opens]="(isMobile$ | async) === false ? 'left' : 'right'"
          [errorMsgObj]="errorMsgObj"
          [calendarHeading]="'common.month-calendar-heading' | translate"
          [closeLabel]="'common.month-close' | translate"
          [prevButtonLabel]="'common.month-previous-button' | translate"
          [nextButtonLabel]="'common.month-next-button' | translate"
          [toggleButtonLabel]="'common.month-toggle-button' | translate"
          [toggleButtonChangeLabel]="'common.month-change-button' | translate"
          [selectedDateLabel]="'common.month-selected-date' | translate"
          (openPanel)="onOpenMonthPicker($event)"
          (monthSelected)="OnMonthSelected($event)"
        ></eds-month-picker>
      </div>
    </div>
  </div>
  <highcharts-chart
    *ngIf="highcharts && chartOptions"
    [Highcharts]="highcharts"
    [options]="chartOptions"
    style="width: 100%; height: 400px; display: block"
  ></highcharts-chart>
</ng-container>
